// import constants types
import {
    VIDFLEET_SHOW_CHANGES_HISTORY_LIST,
    VIDFLEET_SHOW_CHANGES_HISTORY_LIST_RESPONSE,
    VIDFLEET_SHOW_CHANGES_HISTORY_HIDE,
    CLEAR_REDUX,
} from 'Redux/actionTypes';

// initial state
const INIT_STATE = {
    Items: [],
    showChangesHistoryLoading: false,
    error: null,
    errorCode: null,
    openModal: false
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {

        case VIDFLEET_SHOW_CHANGES_HISTORY_LIST:
            return { ...state, showChangesHistoryLoading: true, openModal: true };

        case VIDFLEET_SHOW_CHANGES_HISTORY_LIST_RESPONSE:
            return {
                ...state,
                openModal: true,
                showChangesHistoryLoading: false,
                Items: action?.payload?.result?.configureChangeHistory || [],
                error: action.payload.error,
                errorCode: action.payload.errorCode,

            };
        case VIDFLEET_SHOW_CHANGES_HISTORY_HIDE:
            return { ...INIT_STATE, openModal: false, showChangesHistoryLoading: false, Items: [], error: null, errorCode: null };

        case CLEAR_REDUX:
            return ["", "SHOW_CHANGES_HISTORY"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state }
        default:
            return state;
    }
};
